import axios from "axios";
import { logtoClient } from "../Logto";
import { coreStore } from "../../store";

const { REACT_APP_API_URL: API_URL } = process.env;

export const axiosConsumer = axios.create({
  baseURL: API_URL,
});

export const axiosNoAuth = axios.create({
  baseURL: API_URL,
});

axiosConsumer.interceptors.request.use(async (config) => {
  try {
    const orgId = coreStore.getState().user.selectedOrg.id;
    const authToken = await logtoClient.getOrganizationToken(orgId);
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  } catch (error) {
    await logtoClient.signOut(`${window.location.origin}/`);
    throw new Error("Authentication failed. Redirecting to login.");
  }
});
